import { DefaultPortCandidate, FreeNodePortLocationModel, List, PortCandidateProviderBase, PortCandidateValidity } from "yfiles";
export default class RegularPortCandidateProvider extends PortCandidateProviderBase {
    constructor(node) {
        super();
        this.node = node;
    }
    getPortCandidates(context) {
        const candidates = new List();
        if (context.graph) {
            const item = new DefaultPortCandidate(this.node, FreeNodePortLocationModel.NODE_CENTER_ANCHORED);
            item.validity = PortCandidateValidity.VALID;
            candidates.add(item);
        }
        return candidates;
    }
}
